// extracted by mini-css-extract-plugin
var _1 = "DocFlowCombiningTableRow-moduleDocFlowCombiningTableRow__ROcy1 TableComponent-modulerow__xPAo4";
export { _1 as "DocFlowCombiningTableRow" }
